import { Modal } from "antd";
import { useGlobalContext } from "../../../context/GlobalContext";

const CheckPaymentStatus = () => {
  const { data: globalData, updateData } = useGlobalContext();
  const { openCheckPaymentStatus } = globalData || {};

  const handleClose = () => {
    updateData({ openCheckPaymentStatus: false });
  };

  return (
    <Modal
      open={!!openCheckPaymentStatus}
      onCancel={handleClose}
      title="Check Payment Status"
      footer={null}
      centered
      width={500}
    >
      <div>Check Payment Status</div>
    </Modal>
  );
};

export default CheckPaymentStatus;
